import { Tooltip } from '@poseidon/components/Input2';
import { General } from '@poseidon/components/StrokeIcons';

interface Props {
  /**
   * No connector reaches this node — the spine ended on a `switch`, whose route branches are terminal
   * paths of their own that fan down and to the right. Adds a caption so the pill reads as the end of
   * every branch rather than an orphan floating below the graph.
   */
  detached?: boolean;
}

/**
 * The read-only terminal that closes the sequence spine: where a contact lands once the last step has run
 * ("no more steps" → `terminal.finished`). It isn't an authored step — it can't be dragged, edited or
 * removed — so it's drawn as a green outcome pill rather than a step tile, matching the same node on the
 * full journey graph (`/superadmin/flow`).
 */
export function SequenceFinishedNode({ detached = false }: Props) {
  return (
    <span className="flex flex-col items-center gap-1">
      <Tooltip tooltip="Where a contact lands when the last step has run — the sequence is complete for them. They're no longer being worked, and can be enrolled again later.">
        <span className="flex h-9 cursor-default items-center gap-1.5 rounded-full border border-green-300 bg-green-50 px-3 text-xs font-medium text-green-700 shadow-sm dark:border-green-500/50 dark:bg-green-500/10 dark:text-green-300 [&>svg]:size-4">
          <General.CheckCircle />
          Finished
        </span>
      </Tooltip>
      {detached && (
        <span className="whitespace-nowrap text-[10px] font-medium text-gray-400 dark:text-gray-500">
          every branch ends here
        </span>
      )}
    </span>
  );
}
